/**
 * reCAPTCHA Service
 * Handles interaction with Google reCAPTCHA v3
 */

export class RecaptchaService {
  private siteKey: string;
  private isEnabled: boolean;

  constructor() {
    this.siteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY || '';
    this.isEnabled = !!this.siteKey;

    if (!this.isEnabled) {
      console.warn('reCAPTCHA Site Key not found. reCAPTCHA will be disabled.');
    }
  }

  /**
   * Get the site key
   */
  public getSiteKey(): string {
    return this.siteKey;
  }

  /**
   * Check if reCAPTCHA is enabled
   */
  public isRecaptchaEnabled(): boolean {
    return this.isEnabled;
  }
}

export const recaptchaService = new RecaptchaService();
export default recaptchaService;
